var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-header"},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"content-right"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }